import { useEffect } from 'react';
import { Smartphone } from 'lucide-react';

/**
 * Aplikace na telefonu jen na výšku.
 *
 * Manifest má `orientation: portrait-primary`, jenže to platí jen pro
 * nainstalovanou PWA na Androidu — **iOS orientaci z manifestu ignoruje**
 * a zamknout ji nejde ani skriptem (`screen.orientation.lock` Safari nemá).
 * Na telefonu otočeném na šířku proto aplikaci překryje výzva „Otoč telefon
 * na výšku"; rozvržení pro telefon na šířku nemáme a nedává smysl ho mít.
 *
 * Pozná se to čistě CSS: na šířku + nízká výška + dotykové ovládání. Tablet
 * a desktop (výška nad 500 px nebo myš) zůstávají bez omezení.
 * Kde to prohlížeč umí (Android v režimu aplikace), orientaci navíc zamkne.
 */
export default function OtocNaVysku() {
    useEffect(() => {
        const standalone = window.matchMedia?.('(display-mode: standalone)').matches;
        if (standalone && window.matchMedia?.('(pointer: coarse)').matches) {
            screen.orientation?.lock?.('portrait').catch(() => {});
        }
    }, []);

    return (
        <>
            <style>{`
                .otoc-na-vysku { display: none; }
                @media (orientation: landscape) and (max-height: 500px) and (pointer: coarse) {
                    .otoc-na-vysku {
                        display: flex; position: fixed; inset: 0; z-index: 200000;
                        flex-direction: column; align-items: center; justify-content: center; gap: 14px;
                        background: var(--surface-base, #0a0a0c); color: var(--text-primary, #fff);
                        text-align: center; padding: 24px;
                    }
                    .otoc-na-vysku svg { animation: otoc-na-vysku 1.8s ease-in-out infinite; }
                }
                @keyframes otoc-na-vysku {
                    0%, 20% { transform: rotate(-90deg); }
                    55%, 100% { transform: rotate(0deg); }
                }
                @media (prefers-reduced-motion: reduce) {
                    .otoc-na-vysku svg { animation: none; }
                }
            `}</style>
            <div className="otoc-na-vysku" role="alert">
                <Smartphone size={44} strokeWidth={1.8} />
                <div style={{ fontSize: 17, fontWeight: 700 }}>Otoč telefon na výšku</div>
                <div style={{ fontSize: 13.5, color: 'var(--text-muted, #999)' }}>FofrLama OS je na telefonu stavěná na výšku.</div>
            </div>
        </>
    );
}
